// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-calendar {
  position: relative;
  display: inline-flex;
  width: 100%;
}
.p-calendar .p-inputtext {
  flex: 1 1 auto;
  width: 1%;
}
.p-calendar .p-datepicker {
  min-width: 100%;
}

.p-calendar-w-btn .p-inputtext {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.p-calendar-w-btn .p-datepicker-trigger {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.p-fluid .p-calendar {
  display: flex;
}
.p-fluid .p-calendar .p-inputtext {
  width: 1%;
}

.p-datepicker {
  width: auto;
  position: absolute;
  top: 0;
  left: 0;
}
.p-datepicker table {
  width: 100%;
  border-collapse: collapse;
}
.p-datepicker td > span {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}

.p-datepicker-inline {
  display: inline-block;
  position: static;
  overflow-x: auto;
}

.p-datepicker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.p-datepicker-header .p-datepicker-title {
  margin: 0 auto;
}

.p-datepicker-prev,
.p-datepicker-next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.p-datepicker-multiple-month .p-datepicker-group-container {
  display: flex;
  display: flex;
}
.p-datepicker-multiple-month .p-datepicker-group-container .p-datepicker-group {
  flex: 1 1 auto;
}

.p-monthpicker-month {
  width: 33.3%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}

.p-datepicker-buttonbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.p-timepicker {
  display: flex;
  justify-content: center;
  align-items: center;
}
.p-timepicker button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}
.p-timepicker > div {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.p-datepicker-touch-ui,
.p-calendar .p-datepicker-touch-ui {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 80vw;
  transform: translate(-50%, -50%);
}

.p-yearpicker-year {
  width: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  position: relative;
}

.p-calendar-clear-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  margin-top: -0.5rem;
  cursor: pointer;
}

.p-calendar-clearable {
  position: relative;
}

.p-inputtext.clearable {
  padding-right: 30px;
}

:host.v-timepicker.ng-dirty.ng-invalid .p-inputtext, :host.v-timepicker.pristine-validate.ng-pristine.ng-invalid .p-inputtext {
  border-color: var(--gc-color-danger);
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-timepicker/timepicker.component.sass"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,oBAAA;EACA,WAAA;AACD;AAAC;EACC,cAAA;EACA,SAAA;AAEF;AADC;EACC,eAAA;AAGF;;AADC;EACC,0BAAA;EACA,6BAAA;AAIF;AAHC;EACC,yBAAA;EACA,4BAAA;AAKF;;AAHC;EACC,aAAA;AAMF;AALE;EACC,SAAA;AAOH;;AANA;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AASD;AARC;EACC,WAAA;EACA,yBAAA;AAUF;AARE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAUH;;AATA;EACC,qBAAA;EACA,gBAAA;EACA,gBAAA;AAYD;;AAXA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AAcD;AAbC;EACC,cAAA;AAeF;;AAdA;;EAEC,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAiBD;;AAfC;EACC,aAAA;EACA,aAAA;AAkBF;AAjBE;EACC,cAAA;AAmBH;;AAlBA;EACC,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAqBD;;AApBA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAuBD;;AAtBA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AAyBD;AAxBC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA0BF;AAzBC;EACC,aAAA;EACA,mBAAA;EACA,sBAAA;AA2BF;;AA1BA;;EAEC,eAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gCAAA;AA6BD;;AA5BA;EACC,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA+BD;;AA9BA;EACC,kBAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AAiCD;;AAhCA;EACC,kBAAA;AAmCD;;AAjCA;EACC,mBAAA;AAoCD;;AA/BE;EACC,oCAAA;AAkCH","sourcesContent":[".p-calendar \n\tposition: relative \n\tdisplay: inline-flex \n\twidth: 100% \n\t.p-inputtext \n\t\tflex: 1 1 auto \n\t\twidth: 1% \n\t.p-datepicker \n\t\tmin-width: 100% \n.p-calendar-w-btn \n\t.p-inputtext \n\t\tborder-top-right-radius: 0 \n\t\tborder-bottom-right-radius: 0 \n\t.p-datepicker-trigger \n\t\tborder-top-left-radius: 0 \n\t\tborder-bottom-left-radius: 0 \n.p-fluid \n\t.p-calendar \n\t\tdisplay: flex \n\t\t.p-inputtext \n\t\t\twidth: 1% \n.p-datepicker \n\twidth: auto \n\tposition: absolute \n\ttop: 0 \n\tleft: 0 \n\ttable \n\t\twidth: 100% \n\t\tborder-collapse: collapse \n\ttd \n\t\t& > span \n\t\t\tdisplay: flex \n\t\t\tjustify-content: center \n\t\t\talign-items: center \n\t\t\tcursor: pointer \n\t\t\tmargin: 0 auto \n\t\t\toverflow: hidden \n\t\t\tposition: relative \n.p-datepicker-inline \n\tdisplay: inline-block \n\tposition: static \n\toverflow-x: auto \n.p-datepicker-header \n\tdisplay: flex \n\talign-items: center \n\tjustify-content: space-between \n\t.p-datepicker-title \n\t\tmargin: 0 auto \n.p-datepicker-prev,\n.p-datepicker-next \n\tcursor: pointer \n\tdisplay: inline-flex \n\tjustify-content: center \n\talign-items: center \n\toverflow: hidden \n\tposition: relative \n.p-datepicker-multiple-month \n\t.p-datepicker-group-container \n\t\tdisplay: flex \n\t\tdisplay: flex \n\t\t.p-datepicker-group \n\t\t\tflex: 1 1 auto \n.p-monthpicker-month \n\twidth: 33.3% \n\tdisplay: inline-flex \n\talign-items: center \n\tjustify-content: center \n\tcursor: pointer \n\toverflow: hidden \n\tposition: relative \n.p-datepicker-buttonbar \n\tdisplay: flex \n\tjustify-content: space-between \n\talign-items: center \n.p-timepicker \n\tdisplay: flex \n\tjustify-content: center \n\talign-items: center \n\tbutton \n\t\tdisplay: flex \n\t\talign-items: center \n\t\tjustify-content: center \n\t\tcursor: pointer \n\t\toverflow: hidden \n\t\tposition: relative \n\t& > div \n\t\tdisplay: flex \n\t\talign-items: center \n\t\tflex-direction: column \n.p-datepicker-touch-ui,\n.p-calendar .p-datepicker-touch-ui \n\tposition: fixed \n\ttop: 50% \n\tleft: 50% \n\tmin-width: 80vw \n\ttransform: translate(-50%, -50%) \n.p-yearpicker-year \n\twidth: 50% \n\tdisplay: inline-flex \n\talign-items: center \n\tjustify-content: center \n\tcursor: pointer \n\toverflow: hidden \n\tposition: relative \n.p-calendar-clear-icon \n\tposition: absolute \n\ttop: 50% \n\tright: 10px\n\tmargin-top: -.5rem \n\tcursor: pointer \n.p-calendar-clearable \n\tposition: relative \n\n.p-inputtext.clearable\n\tpadding-right: 30px\n\n\n:host\n\t&.v-timepicker.ng-dirty.ng-invalid, &.v-timepicker.pristine-validate.ng-pristine.ng-invalid\n\t\t.p-inputtext\n\t\t\tborder-color: var(--gc-color-danger)"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
